import { ROUTE_TEXT_MATERIALS_CATEGORIES, ROUTE_TEXT_MATERIALS_MANAGEMENT, ROUTE_TEXT_MATERIALS_THEMES } from '@@partner:config/routes'
import { usePartner } from '@@partner:helpers/hooks/auth'
import React from 'react'
import { BookOutline } from 'react-ionicons'
import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'
import TreeIcon from '@rsuite/icons/Tree'
import GridIcon from '@rsuite/icons/Grid'

export default function TextMaterialsTopMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<BookOutline />}
          as={NavLink}
          to={generatePath(ROUTE_TEXT_MATERIALS_MANAGEMENT, { brandSlug })}
        >Материалы</Nav.Item>
        <Nav.Item
          icon={<TreeIcon />}
          as={NavLink}
          to={generatePath(ROUTE_TEXT_MATERIALS_CATEGORIES, { brandSlug })}
        >Категории</Nav.Item>
        {/*         <Nav.Item
          icon={<LayersOutline />}
          as={NavLink}
          to={generatePath(ROUTE_TEXT_MATERIALS_TYPES, { brandSlug })}
        >Типы</Nav.Item> */}
        <Nav.Item
          icon={<GridIcon />}
          as={NavLink}
          to={generatePath(ROUTE_TEXT_MATERIALS_THEMES, { brandSlug })}
        >Темы</Nav.Item>
        
      </Nav>
    </Navbar>
  )
}